import styled from "styled-components"

import { statFallback } from '../Stat'

import MainWrapper from "../elements/Wrapper"
import Content from "../elements/Content"

import errIcon from '../../assets/error-icon.svg'

const Wrapper = styled.div`
    width: 560px;
    padding: 32px 24px;
    margin-top: 44px;

    display: flex;
    flex-direction: column;
    align-items: center;

    background: #FFFFFF;
    box-shadow: 0px 12px 20px rgba(0, 108, 130, 0.4);
    border-radius: 12px;

    @media screen and (max-width: 640px) {
        width: 460px;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
        padding: 40px 16px;
    }
`

const Container = styled.div`
    width: 100%;
    margin-bottom: 8px;

    display: flex;
    flex-direction: row;
    align-items: center;

    @media screen and (max-width: 480px) {
        flex-direction: column;
    }
`

const LeftContainer = styled.div`
    margin-right: 24px;

    @media screen and (max-width: 480px) {
        margin-right: 0;
    }
`

const RightContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media screen and (max-width: 480px) {
        width: 100%;
        align-items: center;
    }
`

const Icon = styled.img`
    width: 50px;
    height: 60px;
    margin-bottom: 33px;

    @media screen and (max-width: 480px) {
        width: 30px;
        height: 36px;
        margin-bottom: 20px;
    }
`

const Title = styled.div`
    margin-bottom: 18px;

    text-align: center;
    color: #606060;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 38px;

    @media screen and (max-width: 480px) {
        margin-bottom: 19px;

        font-size: 24px;
        line-height: 32px;
    }
`

const Description = styled.div`
    margin-bottom: 24px;

    text-align: center;
    color: #606060;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;

    @media screen and (max-width: 480px) {
        font-size: 14px;
        line-height: 20px;
    }
`

const Button = styled.button`
    width: 160px;
    padding: 16px 0;

    background: #FC531B;
    border: none;
    border-radius: 12px;

    color: #FFFFFF;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    text-align: center;

    text-decoration: none;
    cursor: pointer;
    user-select: none;
    transition: background .3s;

    &:hover {
        background: #FF6D3D;
    }

    &:active {
        background: #EA4C18;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
    }
`

const Fallback = ({
    error,
}: {
    error: Error,
}) => {
    statFallback({
        message: error.message
    })

    return (
        <MainWrapper>
            <Content>
                <Wrapper>
                    <Container>
                        <LeftContainer>
                            <Icon src={errIcon} />
                        </LeftContainer>
                        <RightContainer>
                            <Title>Something went wrong</Title>
                            <Description>Your browser does not support this application</Description>
                        </RightContainer>
                    </Container>
                    <Button onClick={
                        () => location.reload()
                    }>Reload page</Button>
                </Wrapper>
            </Content>
        </MainWrapper>
    )
}

export default Fallback